// Constants for this module.

/**
 * The SPA route the IdP redirects back to after authorize. The path is registered as an allowed
 * callback URL on the IdP tenant and is masked in the WAF logs, so its value must not change
 * without updating both.
 */
export const IDP_CALLBACK_PATH = "/auth0/callback";

/**
 * OAuth / OIDC error codes the app reacts to.
 */
export const IdPErrorCode = {
  LOGIN_REQUIRED: "login_required",
  INTERACTION_REQUIRED: "interaction_required",
  CONSENT_REQUIRED: "consent_required",
  ACCOUNT_SELECTION_REQUIRED: "account_selection_required",
  /** Not an OAuth code: the IdP client's name for a failure without one. */
  UNKNOWN_ERROR: "unknown_error",
} as const;

/**
 * The errors a `prompt=none` authorize answers with when the IdP needs to show the user a page
 * (OIDC Core §3.1.2.6). After a silent attempt they mean "log in interactively".
 */
const SILENT_LOGIN_FALLBACK_ERRORS: readonly string[] = [
  IdPErrorCode.LOGIN_REQUIRED,
  IdPErrorCode.INTERACTION_REQUIRED,
  IdPErrorCode.CONSENT_REQUIRED,
  IdPErrorCode.ACCOUNT_SELECTION_REQUIRED,
];

/**
 * Whether a callback error is one a silent attempt falls back to an interactive login for.
 */
export const isSilentLoginFallbackError = (error: string | undefined): boolean =>
  !!error && SILENT_LOGIN_FALLBACK_ERRORS.includes(error);
